import { usePropertyCounty } from '../../../../../queries/usePropertyCoreFields';
import { CountyDropDown } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface PropertyAddressCountyProps {
    propertyGuid: string;
    required?: boolean;
    selectedState?: string;
    readOnly?: boolean;
    isReview?: boolean;
    validator?: React.ReactNode;
}

export const PropertyAddressCounty: React.FC<PropertyAddressCountyProps> = ({
    propertyGuid,
    required = false,
    selectedState,
    readOnly = false,
    isReview = false,
    validator,
}) => {
    const label = 'County';
    const [propertyAddressCounty, set_propertyAddressCounty] = usePropertyCounty(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={propertyAddressCounty}
                />
            ) : (
                <CountyDropDown
                    id='propertyAddressCounty'
                    value={propertyAddressCounty ?? ''}
                    onChange={(value) => set_propertyAddressCounty(value)}
                    label='County'
                    required={required}
                    selectedState={selectedState}
                    width='100%'
                    readOnly={readOnly}
                    validator={validator}
                />
            )}
        </>
    );
};
